export class SalaryClassTranslateModel  {
    name = {
        en: '',
        de: '',
        fr: '',
        it: '',
    };
}
